import loadjs from 'loadjs';

export const loadModule = ({module, files = [], async = false, success}) => {
    loadjs.isDefined(module) ? loadjs.ready(module, success) : loadjs(files, module, {
        async: async,
        success: success
    });
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/util/loadjsUtil.js